import React from 'react'
import {v4 as uuidv4} from 'uuid'
import {colors} from '../../constants'
import {Link} from '@chakra-ui/react'

export const LinkRendererBlogOptions = (node, children) => {
    // TODO: Add title case for text
    return (
        <Link
            key={uuidv4()}
            href={node.data?.uri}
            color={colors.black}
            padding="none"
            _hover={{
                backgroundColor: 'none',
                color: colors.black
            }}
            isExternal
            px="0"
        >
            {children}
        </Link>
    )
}
